<template>   
    <div class="flex flex-row w-full" >
      <div class="centercontent grow-0" style="width:64px">{{rowItem.date | formatDate('DD/MM/YYYY')}}</div>
      <div class="centercontent grow-0" style="width:90px">{{rowItem.date | formatDate('HH:mm:ss UTC')}}</div>
      <div class="centercontent grow-0" style="width:46px">{{rowItem.rowType}}</div>
      <div class="centercontent grow-0" style="width:40px">{{rowItem.cycle}}</div>
      <div :style="{color}" :title="rowItem.data" class="leftcontent grow">{{rowItem.data}}</div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex'    
  import { ConsoleRow } from '@/models/ui/ConsoleRow'
  export default {  
   name: 'MissionDetailConsoleRaw',   
    props:  {
      rowItem:{
        type:Object,
        required:true
      }
    },        
   computed: {
       ...mapGetters([                     
      ]),
      color(){
        return this.rowItem.rowType == "IRIS"?"#00BB00":
                this.rowItem.rowType == "GLIDER"?"#017E8F":"#DD0000"
      }    
    },
    methods: {
    }  
  }
</script>
<style scoped>
  .centercontent{    
    border-bottom: 1px solid #ccc;    
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    text-align: center;       
    min-width: min-content;
    flex-shrink: 0;
  }


  .leftcontent{
    border-bottom: 1px solid #ccc;    
    display: flex;
    align-items: center;
    justify-content: left;
    min-height: 24px;    
    min-width: min-content;
  }
</style>
